import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/src/jquery.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './assets/theme.css'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCpoLcwxP_lbypFqsX3BJaC1JTHj2Cv0Iw",
    authDomain: "marketing-toolbox-6a462.firebaseapp.com",
    projectId: "marketing-toolbox-6a462",
    storageBucket: "marketing-toolbox-6a462.appspot.com",
    messagingSenderId: "213295066571",
    appId: "1:213295066571:web:db214f3af8b02839625a4e",
    measurementId: "G-WCSD39MDGB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);



createApp(App).use(store).use(router).mount('#app')


